import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LivenBlitzQuestion } from 'onboarding/question/analysisloader/BlitzQuestion';
import styles from './styles.module.scss';

type Props = {
  visible: boolean;
  question: LivenBlitzQuestion;
  onAnswer: () => void;
};

export const QuestionAlert = ({ visible, question, onAnswer }: Props) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  useEffect(() => {
    if (visible) {
      // appAnalytics.trackEvent(new BlitzAlertViewed(question.id));
      setSelectedOption('');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [visible]);

  const handleYesClicked = (e: SyntheticEvent) => {
    e.preventDefault();
    if (selectedOption === '') {
      setSelectedOption('yes');
      onAnswer();
      // appAnalytics.trackEvent(new SaveAnswer(question.id, 'yes'));
      //   setTimeout(() => {
      //     dispatch(setAnswer(question.id, 'yes', features, false));
      //     onAnswer();
      //   }, 200);
    }
  };

  const handleNoClicked = (e: SyntheticEvent) => {
    e.preventDefault();
    if (selectedOption === '') {
      setSelectedOption('no');
      onAnswer();
    }
  };

  return (
    <div className={`${styles.background} ${visible ? '' : styles.hidden}`}>
      <div className={styles.container}>
        <h2 className={styles.title}>{t(question.title)}</h2>
        <div className={styles.buttons}>
          <button
            className={`${styles.button} ${
              selectedOption === 'no' ? styles.active : ''
            }`}
            onClick={handleNoClicked}
          >
            {t('no')}
          </button>
          <button
            className={`${styles.button} ${
              selectedOption === 'yes' ? styles.active : ''
            }`}
            onClick={handleYesClicked}
          >
            {t('yes')}
          </button>
        </div>
      </div>
    </div>
  );
};
